import React from 'react';
import * as Ons from 'react-onsenui';
import ons from 'onsenui';
import Login from '../containers/Pages/Login';
import Navigator from '../containers/Navigator';
import ErrorBoundary from './ErrorBoundary';
import Menu from './Menu';
import PWAInstaller from './PWAInstaller';
import { translate as _ } from '../util/i18n';
import { reload } from '../util';
import { ENV } from '../util/env';

class App extends React.Component {

    constructor( props ) {

        super( props );

        this.state = {

            appUpdateAvailable: false,
            showMenu:           false,
            updatingApp:        false

        };

        this.handleHideAppUpdateNotification = this.handleHideAppUpdateNotification.bind( this );
        this.handleLogout                    = this.handleLogout.bind( this );
        this.handleMenuClick                 = this.handleMenuClick.bind( this );
        this.handleSplitterSideClose         = this.handleSplitterSideClose.bind( this );
        this.handleUpdateApp                 = this.handleUpdateApp.bind( this );

        if ( ons.platform.isIPhoneX() && navigator.standalone ) {

            document.documentElement.setAttribute( 'onsflag-iphonex-landscape', '' );
            document.documentElement.setAttribute( 'onsflag-iphonex-portrait',  '' );

        }

        // TODO test
        window.addEventListener( 'load',     () => window.history.pushState( {}, '' ) );
        window.addEventListener( 'popstate', () => window.history.pushState( {}, '' ) );

        // window.history.pushState( null, null, window.location.href );
        // window.history.back();
        // window.history.forward();
        // /test

        window.appLanguage = this.props.userSettings.language;

        const appearanceModes = [

            window.matchMedia && window.matchMedia( '(prefers-color-scheme: dark)' ).matches ? 'dark' : 'light',
            'light',
            'dark'

        ];

        const appearanceMode    = appearanceModes[ this.props.userSettings.appearanceMode ];
        document.body.className = appearanceMode + '-mode';

        import( 'onsenui/css/' + ( appearanceMode === 'dark' ? 'dark-' : '' ) + 'onsen-css-components.css' );

    }

    componentDidMount() {

        this.props.error            && this.props.onDismissError();
        this.props.loading          && this.props.onIsLoading( false );
        this.props.loadingSucceeded && this.props.onDismissLoadingSucceeded();

        setTimeout( () => {

            if ( window.appUpdateAvailable ) {

                this.setState( { appUpdateAvailable: true } );

                setTimeout( () => this.setState( { appUpdateAvailable: false } ), 1000 * 60 );

            }

        }, 1000 * 5 );

    }

    handleHideAppUpdateNotification() {

        this.setState( { appUpdateAvailable: false } );

    }

    handleMenuClick() {

        this.setState( { showMenu: true } );

    }

    handleLogout() {

        this.setState( { showMenu: false }, () => this.props.onLogout( this.props.context, this.props.token ) );

    }

    handleSplitterSideClose() {

        this.setState( { showMenu: false } );

    }

    handleUpdateApp() {

        this.setState( { updatingApp: true }, () => {

            caches.keys().then( keys => {

                keys.forEach( c => caches.delete( c ) );

            } ).then( () => {

                setTimeout( reload, 1000 * 3 );

            } );

        } );

    }

    render() {

        // console.log( 'components.App.render()', this.props, this.state );

        return (

            <ErrorBoundary>

                { this.props.token && ! this.props.resetPasswordToken ?

                    <Ons.Splitter>

                        <Ons.SplitterContent>
                            <Navigator onMenuClick={this.handleMenuClick} />
                        </Ons.SplitterContent>

                        <Ons.SplitterSide
                            collapse={true}
                            isOpen={this.state.showMenu}
                            onClose={this.handleSplitterSideClose}
                            side="right"
                            swipeable={true}
                            width={300}
                        >
                            <Menu onLogout={this.handleLogout} onClose={this.handleSplitterSideClose} username={this.props.username} />
                        </Ons.SplitterSide>

                    </Ons.Splitter>

                :

                    <Login />

                }

                <PWAInstaller />

                <Ons.Toast isOpen={this.state.appUpdateAvailable}>

                    <div className="toast__message">

                        <p>{_( 'Eine neue App-Version ist verfügbar!' )}</p>

                        <Ons.Button onClick={this.handleUpdateApp} disabled={this.state.updatingApp}>{_( this.state.updatingApp ? 'Installiere...' : 'Jetzt installieren' )}</Ons.Button>

                    </div>

                    <button className="toast__button"><i className="fa fa-times" onClick={this.handleHideAppUpdateNotification} /></button>

                </Ons.Toast>

                {ENV === 'development' && <div className={"environment environment-" + ENV}>{ENV.toUpperCase()}</div>}

            </ErrorBoundary>

        );

    }

}

export default App;